import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import WebTechPage from "./pages/WebTechPage";
import ContactPage from "./pages/ContactPage";
import RegulationsPage from "./pages/RegulationsPage";
import FxProductPage from "./pages/FxProductPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";

function RedirectSolution() {
  const { slug } = useParams();
  return <Navigate to={`/solutions/${slug}`} replace />;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="top-right" />;
}

function App() {
  return (
    <ThemeProvider>
      <HelmetProvider>
        <ThemedToaster />
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/web-tech" element={<WebTechPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/regulations" element={<RegulationsPage />} />
            <Route path="/solutions/:slug" element={<FxProductPage />} />
            <Route path="/services/:slug" element={<ServiceDetailPage />} />
            <Route path="/fx-technology" element={<Navigate to="/solutions/forex-crm" replace />} />
            <Route path="/fx-technology/:slug" element={<RedirectSolution />} />
            <Route path="/funded-form" element={<Navigate to="/solutions/crm-marketing-prop-firm" replace />} />
            <Route path="/funded-form/:slug" element={<RedirectSolution />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </ThemeProvider>
  );
}

export default App;
